import { Card } from '@mantine/core';
import { IconInfoSquareRounded } from '@tabler/icons-react';
import { Section, SectionProps } from './Section';
import { useClaimFormContext } from 'pages/claims/components';
import { groupDebitEOBs } from 'utils/eobUtils';

export const ClaimEOBSection = ({
  index,
  title,
  editComponentsMap,
  type = 'edit',
}: SectionProps) => {
  const form = useClaimFormContext().editForm;
  const borderColor = 'yellow';
  const groupedEOBs = groupDebitEOBs(form?.getValues().debits || []);

  return (
    <>
      {groupedEOBs.length > 0 && (
        <Card
          padding={'md'}
          shadow="xs"
          radius="md"
          withBorder
          style={{ borderColor: borderColor }}
        >
          <Section
            index={index}
            title={title}
            icon={<IconInfoSquareRounded size={20} />}
            keys={['debits.eobs']}
            cols={1}
            editComponentsMap={editComponentsMap}
            type={type}
          />
        </Card>
      )}
    </>
  );
};
